module.exports = __webpack_public_path__ + "Hgo13k-tfSpn0qi1SFdUfT8E0i7KZn-EPnyo3HZu7kw.ecce92d0b0ff17197f29.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto/Hgo13k-tfSpn0qi1SFdUfT8E0i7KZn-EPnyo3HZu7kw.woff
// module id = 781
// module chunks = 1